import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ModalActionButton {
  id: string;
  label?: string;
  icon?: string;
  tooltip?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Modal';
  @Input() showLoading: boolean = false;
  @Input() loadingMessage: string = 'Cargando...';
  @Input() closeButtonLabel: string = 'Cerrar';

  // Configuración del botón adicional junto al título (compatibilidad hacia atrás)
  @Input() showActionButton: boolean = false;
  @Input() actionButtonLabel: string = '';
  @Input() actionButtonIcon: string = '';
  @Input() actionButtonTooltip: string = '';
  @Input() actionButtonDisabled: boolean = false;
  @Output() actionButtonClick = new EventEmitter<void>();

  // Botones de acción adicionales junto al título (admite varios botones)
  @Input() actionButtons: ModalActionButton[] = [];
  @Output() actionButtonsClick = new EventEmitter<string>();

  @Output() closeModal = new EventEmitter<void>();

  onCloseModal() {
    this.closeModal.emit();
  }

  onActionButtonClick() {
    if (!this.actionButtonDisabled) {
      this.actionButtonClick.emit();
    }
  }

  onActionButtonsClick(button: ModalActionButton) {
    if (!button.disabled) {
      this.actionButtonsClick.emit(button.id);
    }
  }

  trackByButtonId(index: number, button: ModalActionButton): string {
    return button.id;
  }
}